import { render, staticRenderFns } from "./PopupClosedFrameQuote.vue?vue&type=template&id=4f81e567&scoped=true"
import script from "./PopupClosedFrameQuote.vue?vue&type=script&lang=js"
export * from "./PopupClosedFrameQuote.vue?vue&type=script&lang=js"
import style0 from "./PopupClosedFrameQuote.vue?vue&type=style&index=0&id=4f81e567&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f81e567",
  null
  
)

export default component.exports